import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: "[dtmUiCarouselSlides]",
})
export class CarouselSlidesDirective {
    constructor(public template: TemplateRef<HTMLElement>) {}
}
